module.exports = {
	"ha": "bc",
	"id": 1.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.7</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Males in BC by Health Authority <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2013",
					"2013",
					"2014",
					"2014",
					"2014",
					"2014",
					"2015",
					"2015",
					"2015",
					"2015",
					"2016",
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018",
					"2018"
				],
				"tickPositions": [
					0,
					2,
					6,
					10,
					14,
					18
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					6.737,
					6.463,
					6.915,
					7.105,
					7.328,
					7.463,
					8.095,
					7.843,
					8.409,
					8.643,
					9.356,
					9.576,
					9.127,
					8.718,
					9.236,
					9.394,
					9.026,
					8.849,
					9.818,
					{
						"y": 10.194,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					2.32,
					2.401,
					2.612,
					2.765,
					2.695,
					2.863,
					3.193,
					3.403,
					3.761,
					4.379,
					5.089,
					4.817,
					4.376,
					4.275,
					4.885,
					4.693,
					4.471,
					4.677,
					4.946,
					{
						"y": 5.037,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.1,
					1.18,
					1.387,
					1.316,
					1.278,
					1.359,
					1.618,
					1.439,
					1.457,
					1.422,
					1.63,
					1.546,
					1.407,
					1.435,
					1.753,
					1.714,
					1.619,
					1.584,
					1.855,
					{
						"y": 1.896,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					14.391,
					14.259,
					16.84,
					18.294,
					20.402,
					19.837,
					21.746,
					21.417,
					21.89,
					21.697,
					24.11,
					23.335,
					22.686,
					22.299,
					23.927,
					23.405,
					22.858,
					22.113,
					24.877,
					{
						"y": 24.382,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					1.963,
					1.937,
					2.224,
					2.134,
					2.121,
					2.139,
					2.576,
					2.583,
					2.761,
					2.919,
					3.147,
					3.218,
					2.845,
					2.855,
					3.056,
					2.789,
					2.98,
					3.023,
					3.345,
					{
						"y": 3.295,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_1_7.json
// module id = 152
// module chunks = 0